import { sanitise } from '@/domain/utils/DataSanitiser';
import { VNodeDirective } from 'vue';

const bind = (el: Element, binding: VNodeDirective) => {
	el.innerHTML = sanitise(binding.value) ?? '';
};

const update = (el: Element, binding: VNodeDirective) => {
	if (binding.value === binding.oldValue) return;
	el.innerHTML = sanitise(binding.value) ?? '';
};

const vOutput = { bind, update };

export default vOutput;
